<script lang="ts">
	interface Props {
		height?: string; // Default height
		width?: string; // Default width
		class?: string;
	}

	let { height = '48px', width = '48px', class: className = '' }: Props = $props();
	
</script>

<svg
	{height}
	{width}
	class={className}
	viewBox="0 0 24 24"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
>
	<path
		d="M16.5 4.5C17.0523 4.5 17.5 4.05228 17.5 3.5C17.5 2.94772 17.0523 2.5 16.5 2.5C15.9477 2.5 15.5 2.94772 15.5 3.5C15.5 4.05228 15.9477 4.5 16.5 4.5Z"
		fill="currentColor"
	/>
	<path
		d="M2.5 14.5C3.05228 14.5 3.5 14.0523 3.5 13.5C3.5 12.9477 3.05228 12.5 2.5 12.5C1.94772 12.5 1.5 12.9477 1.5 13.5C1.5 14.0523 1.94772 14.5 2.5 14.5Z"
		fill="currentColor"
	/>
	<path
		d="M20 13C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11C19.4477 11 19 11.4477 19 12C19 12.5523 19.4477 13 20 13Z"
		fill="currentColor"
	/>
	<path
		d="M4.25 3H4.75C4.88807 3 5 3.11193 5 3.25V3.75C5 4.16421 5.33579 4.5 5.75 4.5C6.16421 4.5 6.5 4.16421 6.5 3.75V3.25C6.5 3.11193 6.61193 3 6.75 3H7.25C7.66421 3 8 2.66421 8 2.25C8 1.83579 7.66421 1.5 7.25 1.5H6.75C6.61193 1.5 6.5 1.38807 6.5 1.25V0.75C6.5 0.335786 6.16421 0 5.75 0C5.33579 0 5 0.335786 5 0.75V1.25C5 1.38807 4.88807 1.5 4.75 1.5H4.25C3.83579 1.5 3.5 1.83579 3.5 2.25C3.5 2.66421 3.83579 3 4.25 3Z"
		fill="currentColor"
	/>
	<path
		d="M2.318 5.82C2.05308 5.79018 1.7874 5.86912 1.58175 6.03877C1.3761 6.20841 1.24809 6.45424 1.227 6.72C1.17481 7.26944 1.57761 7.75728 2.127 7.81C4.34825 8.03843 6.46687 8.86129 8.26 10.192C8.36815 10.2717 8.50382 10.3045 8.63645 10.2831C8.76907 10.2616 8.88748 10.1877 8.965 10.078C9.13595 9.83569 9.33501 9.61448 9.558 9.419C9.67164 9.31961 9.73429 9.1742 9.72847 9.02334C9.72265 8.87248 9.64897 8.73233 9.528 8.642C7.42614 7.06294 4.93331 6.08724 2.318 5.82V5.82Z"
		fill="currentColor"
	/>
	<path
		d="M11.566 8.525C11.7101 8.50856 11.855 8.50021 12 8.5C12.1497 8.4999 12.2994 8.50892 12.448 8.527C12.5907 8.54425 12.7338 8.49929 12.841 8.40358C12.9482 8.30788 13.009 8.17069 13.008 8.027V2.5C13.008 1.94772 12.5603 1.5 12.008 1.5C11.4557 1.5 11.008 1.94772 11.008 2.5V8.028C11.007 8.1713 11.0676 8.30812 11.1743 8.40375C11.281 8.49938 11.4237 8.54463 11.566 8.528V8.525Z"
		fill="currentColor"
	/>
	<path
		d="M8.392 13.077C8.35451 12.9209 8.24431 12.7922 8.09576 12.7312C7.94722 12.6702 7.77841 12.6843 7.642 12.769C5.61186 14.2192 4.07124 16.253 3.225 18.6C3.05929 19.1166 3.33578 19.6712 3.84811 19.8497C4.36045 20.0283 4.92171 19.7657 5.113 19.258C5.80049 17.41 6.98843 15.7896 8.544 14.578C8.75676 14.4367 8.82877 14.1577 8.711 13.931C8.56911 13.6609 8.46192 13.374 8.392 13.077V13.077Z"
		fill="currentColor"
	/>
	<path
		d="M16.358 12.769C16.2216 12.6843 16.0528 12.6702 15.9042 12.7312C15.7557 12.7922 15.6455 12.9209 15.608 13.077C15.537 13.3721 15.4299 13.6572 15.289 13.926C15.1704 14.1527 15.242 14.4323 15.455 14.574C17.0107 15.7857 18.199 17.406 18.887 19.254C19.0783 19.7617 19.6395 20.0243 20.1519 19.8457C20.6642 19.6672 20.9407 19.1126 20.775 18.596C19.928 16.2505 18.3875 14.2181 16.358 12.769Z"
		fill="currentColor"
	/>
	<path
		d="M21.682 5.82C19.0666 6.08694 16.5737 7.06267 14.472 8.642C14.3509 8.73217 14.277 8.87224 14.271 9.0231C14.265 9.17396 14.3275 9.31947 14.441 9.419C14.6643 9.61422 14.8633 9.83546 15.034 10.078C15.1115 10.188 15.2301 10.2621 15.363 10.2836C15.4959 10.305 15.6318 10.272 15.74 10.192C17.5329 8.86168 19.6512 8.03917 21.872 7.811C22.4214 7.75828 22.8242 7.27044 22.772 6.721C22.7498 6.4558 22.6217 6.21074 22.4166 6.04118C22.2114 5.87163 21.9466 5.7919 21.682 5.82Z"
		fill="currentColor"
	/>
	<path
		d="M12 10C11.0234 9.99914 10.162 10.6394 9.8813 11.5749C9.60062 12.5103 9.96722 13.519 10.783 14.056C10.9233 14.1484 11.0078 14.305 11.008 14.473V23C11.008 23.5523 11.4557 24 12.008 24C12.5603 24 13.008 23.5523 13.008 23V14.463C13.0076 14.2961 13.0905 14.1401 13.229 14.047C14.0381 13.5059 14.3978 12.4992 14.115 11.5678C13.8322 10.6365 12.9733 9.99984 12 10Z"
		fill="currentColor"
	/>
</svg>
